import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { PN_DRIVE_RENTAL_CONTRACT_STATUS } from "../../utils/Utils";

import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS = Object.keys(PN_DRIVE_RENTAL_CONTRACT_STATUS).map((c) => ({
  label: PN_DRIVE_RENTAL_CONTRACT_STATUS[c],
  value: c,
}));

const DEFAULT_RENTAL_CONTRACT_STATUS = {
  id: "",
  date: moment().format("YYYY-MM-DD"),
  distance: null,
  customerId: null,
  estimateWeight: null,
  status: PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS[0].value,
  info: {
    from: null,
    to: null
  },
  deliveryFeeByDistanceData: []
};

const DriveRentalContract = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    add: false,
    edit: false,
    isDelete: false,
  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch
  } = useForm({
    defaultValues: {
      ...DEFAULT_RENTAL_CONTRACT_STATUS
    },
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [pnCustomerOptions, setPNCustomerOptions] = useState([]);
  const [deliveryFeeByDistance, setDeliveryFeeByDistance] = useState([]);

  const [filter, setFilter] = useState({
    customerId: searchParams.get('customerId'),
    status: searchParams.get('status') || PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS[0].value,
  });
  const {
    fields,
  } = useFieldArray({
    control,
    name: 'deliveryFeeByDistanceData'
  })

  const colTable = [
    {
      Header: "Mã",
      accessor: (item) => item.id,
    },
    {
      Header: "Ngày ký",
      accessor: (item) => moment(item.createdAt).format("DD/MM/YYYY"),
    },
    {
      Header: "Quảng đường",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.distance || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Khối lượng ước tính",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.estimateWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Khối lượng thực tế",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.currentWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số chuyến hiên tại",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.countDelivery || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Điểm đi ",
      accessor: (item) => item?.info?.from,
    },
    {
      Header: "Điểm đến ",
      accessor: (item) => item?.info?.to,
    },
    {
      Header: "Khách hàng",
      accessor: (item) => item.customer?.name,
    },
    {
      Header: "Trạng thái",
      accessor: (item) => PN_DRIVE_RENTAL_CONTRACT_STATUS[item.status],
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    GET("/pn-customer", {}, true).then(({ data }) => {
      setPNCustomerOptions(data.map(c => ({
        label: c.name,
        value: c.id,
        data: c
      })))
    })

    GET(`/delivery-fee-by-distance`, {
      location: 'INTERNAL'
    }, true)
      .then(({ data: { rows: data } }) => {
        const groupByDistance = {};
        data.forEach(({ id, ...c }) => {
          if (!groupByDistance[c.distance]) {
            groupByDistance[c.distance] = [];
          }
          groupByDistance[c.distance].push(c);
        })
        setDeliveryFeeByDistance(Object.entries(groupByDistance).sort((a, b) => a[0] - b[0]));
      })
  }, []);

  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.status ? { status: filter.status } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    let params = {
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.status ? { status: filter.status } : {}),
    };

    GET(`drive-rental-contract`, params, true)
      .then(({ data: { rows } }) => {
        setData([...rows]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const {
      date,
      distance,
      estimateWeight,
      customerId,
      status,
      info,
      deliveryFeeByDistanceData
    } = getValues();

    const formData = {
      date,
      distance,
      estimateWeight,
      customerId,
      status,
      info,
      deliveryFeeByDistanceData
    };

    const request = editId
      ? PUT(`drive-rental-contract/${editId}`, formData, {}, true)
      : POST(`drive-rental-contract`, formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`drive-rental-contract/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, isScan: false });
    reset(DEFAULT_RENTAL_CONTRACT_STATUS);
    setDeleteId();
  };

  const deleteEmloyeePortion = (id) => {
    if (!id) {
      return;
    }
    DELETE(`drive-rental-contract/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const handleOnChangeDistance = (distance) => {
    if (!distance) {
      setValue("deliveryFeeByDistanceData", []);
      return;
    }
    setValue("deliveryFeeByDistanceData", (deliveryFeeByDistance.find(c => c[0] >= distance) || deliveryFeeByDistance[deliveryFeeByDistance.length - 1])[1]);
  }

  return (
    <React.Fragment>
      <Head title="Hợp đồng chạy thuê"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Hợp đồng chạy thuê</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Tìm kiếm KH/NCC"
                          classNamePrefix="form-control"
                          options={pnCustomerOptions}
                          value={pnCustomerOptions.find(
                            (c) => c.value === filter.customerId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          placeholder="Trạng thái"
                          classNamePrefix="form-control"
                          options={PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS}
                          value={PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS.find(
                            (c) => c.value === filter.status
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              status: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm hợp đồng</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          style={{ width: '80vw', maxWidth: '80vw' }}
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"}</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngày ký
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="date"
                            className="form-control"
                            name="date"
                            max={moment().format("YYYY-MM-DD")}
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="date"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Khối lượng ước tính
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="estimateWeight"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="distance"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          KH/NCC
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="customerId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value }) => (
                              <ReactSelect
                                classNamePrefix="form-control"
                                options={pnCustomerOptions}
                                value={pnCustomerOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="customerId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" >
                          Trạng thái <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="status"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            defaultValue={PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS[0].value}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS}
                                value={PN_DRIVE_RENTAL_CONTRACT_STATUS_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="status"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="info.from">
                          Nơi đi
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <textarea
                            rows={3}
                            className="form-control"
                            style={{ height: "unset" }}
                            name="info.from"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="info.from"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="info.to">
                          Nơi đến
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <textarea
                            rows={3}
                            className="form-control"
                            style={{ height: "unset" }}
                            name="info.to"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="date"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Quảng đường
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="distance"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) => {
                                  onChange(val.floatValue)
                                  handleOnChangeDistance(val.floatValue)
                                }}

                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="distance"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md={12}>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Xe</th>
                            <th>Đơn giá(đ)</th>
                            <th>Tiền tài chính(đ)</th>
                            <th>Tiền tài phụ(đ)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            fields.map(({ id, truckIds, deliveryFeeByDistance, driverBonus, subDriverBonus }, index) => (
                              <tr key={id}>
                                <td>
                                  {truckIds?.join(', ')}
                                  <Controller
                                    name={`deliveryFeeByDistanceData.${index}.truckIds`}
                                    control={control}
                                    defaultValue={truckIds}
                                    render={({ onChange, value, ref }) => (
                                      <Input type="hidden" value={value} {...register(`deliveryFeeByDistanceData.${index}.truckIds`)} />
                                    )}
                                  />
                                </td>
                                <td>
                                  <Controller
                                    name={`deliveryFeeByDistanceData.${index}.deliveryFeeByDistance`}
                                    control={control}
                                    defaultValue={deliveryFeeByDistance}
                                    render={({ onChange, value, ref }) => (
                                      <NumericFormat
                                        className="form-control"
                                        inputRef={ref}
                                        type="text"
                                        value={value}
                                        thousandsGroupStyle="thousand"
                                        thousandSeparator=","
                                        decimalScale={2}
                                        onValueChange={(val) =>
                                          onChange(val.floatValue)
                                        }
                                      />
                                    )}
                                  />
                                </td>
                                <td>
                                  <Controller
                                    name={`deliveryFeeByDistanceData.${index}.driverBonus`}
                                    control={control}
                                    defaultValue={driverBonus}
                                    render={({ onChange, value, ref }) => (
                                      <NumericFormat
                                        className="form-control"
                                        inputRef={ref}
                                        type="text"
                                        value={value}
                                        thousandsGroupStyle="thousand"
                                        thousandSeparator=","
                                        decimalScale={2}
                                        onValueChange={(val) =>
                                          onChange(val.floatValue)
                                        }
                                      />
                                    )}
                                  />
                                </td>
                                <td>
                                  <Controller
                                    name={`deliveryFeeByDistanceData.${index}.subDriverBonus`}
                                    control={control}
                                    defaultValue={subDriverBonus}
                                    render={({ onChange, value, ref }) => (
                                      <NumericFormat
                                        className="form-control"
                                        inputRef={ref}
                                        type="text"
                                        value={value}
                                        thousandsGroupStyle="thousand"
                                        thousandSeparator=","
                                        decimalScale={2}
                                        onValueChange={(val) =>
                                          onChange(val.floatValue)
                                        }
                                      />
                                    )}
                                  />
                                </td>
                              </tr>
                            ))
                          }

                        </tbody>
                      </table>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <span>{editId ? "Sửa" : "Thêm"}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá giao dịch này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteEmloyeePortion(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default DriveRentalContract;
